import { AuthService } from '@/app/core/services/auth.service';
import { NotificacionService } from '@/app/core/services/notificacion.service';
import type { Notificacion } from '@/app/models';
import { HttpParams } from '@angular/common/http';
import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'c-notifications',
  templateUrl: './notifications.component.html',
  styleUrl: './notifications.component.css',
  standalone: false,
})
export class NotificationsComponent {
  private readonly service = inject(NotificacionService);
  private readonly auth = inject(AuthService);
  hasNotificaciones() {
    return this.notificaciones.some((n) => !n.abierto);
  }

  notificaciones: Notificacion[] = [];
  count = 0;

  async ngOnInit() {
    const usuario = await this.auth.returnUserInfo();

    const params = new HttpParams().set('usuarioId', usuario?.id_usuario ?? 0);

    this.service.findLatestNotifications(params).subscribe((data) => {
      this.notificaciones = this.order(data.data);
      this.count = data.count;
    });
  }

  private readonly router = inject(Router);
  onClick(i: Notificacion) {
    if (!i.abierto) {
      this.service
        .update(i.id, { abierto: true, fecha_abierto: new Date() })
        .subscribe((data) => {
          const item = this.notificaciones.find((n) => n.id == data.id);
          if (item) Object.assign(item, data);
          this.notificaciones = this.order(this.notificaciones);
        });
    }
    const [path, queryString] = i.url.split('?');
    const queryParams = queryString
      ? Object.fromEntries(new URLSearchParams(queryString) as any)
      : {};

    this.router.navigate([path], { queryParams });
  }

  private order(notificaciones: Notificacion[]) {
    return notificaciones.sort((a, b) => {
      // Primero ordenamos por "abierto" (false primero)
      if (a.abierto !== b.abierto) {
        return a.abierto ? 1 : -1; // false (-1) antes que true (1)
      }

      // Luego ordenamos por "fecha_carga" (más reciente primero)
      return (
        new Date(b.fecha_carga).getTime() - new Date(a.fecha_carga).getTime()
      );
    });
  }
}
